export default __webpack_public_path__ + "static/media/8925.a5676669.svg";